<!-- Enable Feature -->
@if (showEnableFeature) {
  <div class="row button-container">
    <div class="col-2 custom-button">
      <div class="rSet enable-alo-label">
        <label>
          Enable feature
          <input type="checkbox" class="primary-checkbox" name="enableFeature"
            [(ngModel)]="isEnableFeature" (change)="enableFeatureChanged($event.target.checked)" />
            <span class="extra-border-enablefeat" id="AOC-enable-feature"></span>
          </label>
        </div>
      </div>
      <div class="col-8"></div>
      <div class="col-1"></div>
    </div>
  }

  <!-- Number of Channels -->
  <div class="row slider-container mode-margin channel-label flex-nowrap" [ngClass]="{'isResetDisabled': aocDisabled && showEnableFeature}">
    <div class="col-auto label signifyBookmd bold-label" style="white-space: nowrap; flex-shrink: 0;" id="AOC-nrchannels-label">Number of channels</div>
    <div class="col-auto mode-container" style="margin-top: 0.3em; margin-left: 40px; flex-shrink: 0;">
      <select id="AOC-nrchannels-dropdown" class="signifyBookmd select-dimming select-small"
        [(ngModel)]="nrOfChannels" (change)="onNrOfChannelsChange(+nrOfChannels)" [disabled]="aocDisabled && showEnableFeature">
        @for (opt of nrOfChannelsOptions; track opt; let i = $index) {
          <option [value]="opt" class="info-val" [id]="'AOC-nrchannels-option-' + i">{{ opt }}</option>
        }
      </select>
    </div>
    <div class="col-7"></div>
  </div>

  <!-- Channel Sliders - shown based on nrOfChannels -->
  @for (ch of channels; track ch; let i = $index) {
    @if (i < nrOfChannels) {
      <div class="row slider-container channel-label" [ngClass]="{'isResetDisabled': aocDisabled && showEnableFeature}">
        <div class="col-1 label signifyBookmd zero-margin-top bold-label" [id]="'AOC-channel' + (i+1) + '-label'">Channel {{ i + 1 }}</div>
        @if (quickConfigvalue) {
          <div class="col-2">
            <div class="row">
              <div class="col-4"></div>
              <div class="col-2 minValMargin">
                <span [id]="'AOC-channel' + (i+1) + '-STDmin'" class="signifyBookmd minValue"> min {{ ch.min }}</span>
              </div>
              <div class="col-3">
                <span [id]="'AOC-channel' + (i+1) + '-STDmax'" class="signifyBookmd maxValue"> max {{ ch.max }}</span>
              </div>
            </div>
          </div>
        }
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim sliderMinValue col-1" [id]="'AOC-channel' + (i+1) + '-min'">{{ ch.min }}</span>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 curvePadding sliderCss" [id]="'AOC-channel' + (i+1) + '-slider'" [ngClass]="{'isSliderClick': aocDisabled && showEnableFeature}">
            <ngx-slider type="normalType" [id]="'AOC-channel' + (i+1) + '-range'" ngDefaultControl
              [value]="getSliderSafeValue(ch.value, ch.min, ch.max)" [options]="ch.options"
              (userChangeEnd)="channelSliderChange($event.value, i)">
            </ngx-slider>
          </div>
        }
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim col-1 startUpMargin" [id]="'AOC-channel' + (i+1) + '-max'">{{ ch.max }}</span>
        }
        <div class="row form-group col-3">
          <input type="number" [value]="ch.displayValue" step="1"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" [id]="'AOC-channel' + (i+1) + '-input'"
            (input)="onChannelInput($event.target.value, i)" (blur)="onFieldBlur($event.target, i)" [disabled]="aocDisabled && showEnableFeature"
            (keypress)="numberOnly($event)" [ngClass]="{'myStyle': inputError['channel' + i]===true, 'isResetDisabled custom-inputbox-disabled': aocDisabled && showEnableFeature, 'inputCssStandard': quickConfigvalue===true}">
            <p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">mA</p>
          </div>
        </div>
      }
    }
